import {useCallback} from 'react';
import {useHttpsCallableFunction} from './useHttpsCallableFunction';

export const ExtendSessionFunctionName = 'extendSession';

export function useExtendSession(): () => Promise<void> {
  const extendSessionFunction = useHttpsCallableFunction<void, void>(ExtendSessionFunctionName);
  return useCallback(async () => {
    await extendSessionFunction();
  }, [extendSessionFunction]);
}
